module.exports = __webpack_public_path__ + "static/media/12.3ae620ad.png";